angular.module('zc.zenclerkS')
  .controller('ZcsSiteNavigationController', ZcsSiteNavigationController);

ZcsSiteNavigationController.$inject = ['$scope', '$state', 'Devise', 'InterestWidget', 'project'];
function ZcsSiteNavigationController($scope, $state, Devise, InterestWidget, project) {
  const vm = this;

  vm.project = project;
  vm.hasInterestWidgets = false;

  vm.isGroup = isGroup;
  vm.isMaster = false;

  $scope.$watch(() => Devise.isMaster(), () => {
    vm.isMaster = Devise.isMaster();
  });

  InterestWidget.all(vm.project.apikey)
    .then(interestWidgets => {
      const activeIws = _.reject(interestWidgets, iw => iw.status === 'incomplete_setting');
      if(activeIws.length > 0) {
        vm.hasInterestWidgets = true;
      }
    });



  function isGroup(group) {
    return _.get($state, 'current.data.group') === group;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/site_navigation.controller.js